import { PaletteOutlineIcon } from './PaletteOutlineIcon';

/**
 * author: Google
 * id 6C41ED7D-CA9F-45BA-B94D-F20ABB54519B
 * name palette-outline
 * version: 3.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/palette-outline.svg
 * tags
 * - Drawing / Art 
 * - Color 
 * - Geographic Information System 
 */
export const PaintOutlineIcon = PaletteOutlineIcon;
export default PaintOutlineIcon